
import React, { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { Doughnut } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { UserAuth } from '../../auth/Auth';
import { PrivateAxios, url } from '../../../environment/AxiosInstance';
import { useReactToPrint } from 'react-to-print';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import "./report.min.css"
import "./report.css"
import { ErrorMessage } from '../../../environment/ToastMessage';
import Loader from '../../../loader/Loader';
import { calculateDelayInHoursEndTime, isURL } from './../../../environment/Helper';
import moment from 'moment';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const optionsChecksheet = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start', // Left-align the labels
                usePointStyle: true,
                padding: 10,
            },
        },
        // title: {
        //     display: true,
        //     fontSize: 20,
        //     text: 'Checksheet'
        // }
    },
    cutout: '60%',
}

function TaskReportIndex() {

    const { User, userDetails, MDExist,AdminExist } = UserAuth();
    const currentDate = new Date();
    const startDateInput = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const endDateInput = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    const [TaskData, setTaskData] = useState({
        "startDate": startDateInput,
        "endDate": endDateInput,
        "doer_id": "",
        "pie": 0,
        "chat": 0,
    })

    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [reportName, setReportName] = useState([]);
    const GetReport = (data) => {
        setLoading(true)
        PrivateAxios.post('report/dynamic/task-report', data)
            .then((res) => {
                setLoading(false)
                setReportName(res.data.data[0].userId);
                setReportData(res.data.data[0].task);
            }).catch((err) => {
                setLoading(false)
                if (err?.response?.data?.status == false) {
                    ErrorMessage(err?.response?.data?.message)
                }
            })

    }


    const GetReportData = (e) => {
        e.preventDefault();
        GetReport(TaskData)
    }

    // const labels = User.find(item => item.id == reportName)?.name;

    // const BarData = {
    //     labels: [
    //         'Total Task',
    //         'Pending Task',
    //         'Completed Task',
    //         'Assign Task',
    //         'Delay Completed Task',
    //     ],
    //     datasets: [
    //         {
    //             label: 'Task Status',
    //             data: [
    //                 reportData.length,
    //                 reportData.filter(item => item.completed_date == null && calculateDelayInHoursEndTime(item.planned_date, new Date()) !== "0:00").length,
    //                 reportData.filter(item => item.completed_date && calculateDelayInHoursEndTime(item.planned_date, item.completed_date) === '0:00').length,
    //                 reportData.filter(item => item.completed_date == null && calculateDelayInHoursEndTime(item.planned_date, new Date()) === "0:00").length,
    //                 reportData.filter(item => item.completed_date && calculateDelayInHoursEndTime(item.planned_date, item.completed_date) !== "0:00").length,
    //             ],
    //             backgroundColor: [
    //                 'rgb(16, 148, 6)',
    //                 'rgb(255, 230, 43)',
    //                 'rgb(63, 213, 52)',
    //                 'rgb(127, 127, 127)',
    //                 'rgb(89, 71, 208)',
    //             ],
    //         },
    //     ],
    // };
    // const options = {
    //     plugins: {
    //         legend: {
    //             display: false,
    //         },
    //     },
    // };
    const data = {
        labels: [            
            'Pending Task',
            'Completed Task',
            'To Be Completed Task',
            'Delay Completed Task',
        ],
        datasets: [
            {
                data: [                    
                    reportData.filter(item => item.completed_date == null && calculateDelayInHoursEndTime(item.planned_date, new Date()) != "0:00").length || 0,
                    reportData.filter(item => item.completed_date && calculateDelayInHoursEndTime(item.planned_date, item.completed_date) == '0:00').length || 0,
                    reportData.filter(item => item.completed_date == null && calculateDelayInHoursEndTime(item.planned_date, new Date()) == "0:00").length || 0,
                    reportData.filter(item => item.completed_date && calculateDelayInHoursEndTime(item.planned_date, item.completed_date) != "0:00").length || 0
                ],
                backgroundColor: [
                    'rgb(229, 222, 39)',                    
                    'rgb(16, 148, 6)',
                    'rgb(89, 71, 208)',
                    'rgb(244, 27, 27)',
                ],
                borderWidth: 0,
            },
        ],
    };



    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });
    //dark theme select
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    // Check for the theme by looking at the body's class list
    useEffect(() => {
        const checkTheme = () => {
            setIsDarkTheme(document.body.classList.contains("dark-theme"));
        };

        // Initial check
        checkTheme();

        // MutationObserver to detect theme changes on body
        const observer = new MutationObserver(checkTheme);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Clean up observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme select end

    const [hide, setHide] = useState(false);

    //custom range select
    const [selectedRange, setSelectedRange] = useState('3m'); // Default selection
    const [fmsData, setFmsData] = useState({ startDate: null, endDate: null });
    const handleRadioChange = (event) => {
        setSelectedRange(event.target.value);
    };

    return (
        <React.Fragment>
            {loading ? <Loader /> :
                <div className="p-4 task-report-container" ref={contentRef}>
                    <div className="mb-4 d-flex align-items-center justify-content-betweem">
                        <Link className="text-dark back-btn me-3" to="/reports">
                            <i className="fas fa-long-arrow-alt-left me-1" />Back
                        </Link>
                    </div>
                    <div className="container-fluid px-0">
                        <div className="row">
                            <div className="col-12">
                                <div className='card mb-4 task-report-filter-card'>
                                    <div className="card-header bg-white">
                                        <h3 className="card-title mb-0">
                                            <i className="fas fa-filter me-2 text-primary"></i>
                                            One Time Task Report
                                        </h3>
                                    </div>
                                    <form onSubmit={GetReportData}>
                                        <div className='card-body task-report-filter-body'>
                                            <div className='row g-4'>
                                                {/* Doer Name Dropdown */}
                                                <div className='col-lg-6 col-md-6'>
                                                    <label className='form-label'>Doer Name <span className='text-exp-red'>*</span></label>
                                                    <div className='custom-select-wrap'>
                                                        <Select
                                                            required
                                                            name='doerName'
                                                            options={MDExist ||AdminExist  ? User : userDetails.branch_position == "HOD" ? User.filter(item => item.departments_id == userDetails.departments_id && item.branch_id == userDetails.branch_id) : User.filter(item => item.id == userDetails.id)}
                                                            getOptionLabel={(option) => option.name}
                                                            getOptionValue={(option) => option.id}
                                                            value={User.find(item => item.id == reportName)}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#ddddff',
                                                                    primary: '#6161ff',
                                                                },
                                                            })}
                                                            onChange={(data) => {
                                                                const MultiDoers = JSON.stringify([data.id]);
                                                                setTaskData({ ...TaskData, doer_id: MultiDoers })
                                                            }}
                                                            styles={{
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: isDarkTheme ? "#06162f" : "#ffffff",
                                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isFocused ? (isDarkTheme ? "#112a46" : "#ddddff") : "transparent",
                                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* From Date */}
                                                <div className='col-lg-3 col-md-6'>
                                                    <label className='form-label'>From <span className='text-exp-red'>*</span></label>
                                                    <div className="exp-datepicker-cont">
                                                        <span className="cal-icon"><i className="fas fa-calendar-alt" /></span>
                                                        <DatePicker
                                                            required
                                                            selected={TaskData.startDate}
                                                            onChange={(date) => setTaskData({ ...TaskData, startDate: date })}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText='Select Date'
                                                        />
                                                    </div>
                                                </div>

                                                {/* To Date */}
                                                <div className='col-lg-3 col-md-6'>
                                                    <label className='form-label'>To <span className='text-exp-red'>*</span></label>
                                                    <div className="exp-datepicker-cont">
                                                        <span className="cal-icon"><i className="fas fa-calendar-alt" /></span>
                                                        <DatePicker
                                                            required
                                                            selected={TaskData.endDate}
                                                            onChange={(date) => setTaskData({ ...TaskData, endDate: date })}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText='Select Date'
                                                        />
                                                    </div>
                                                </div>

                                                {/* Pie Chart Checkbox */}
                                                <div className='col-12'>
                                                    <div className='d-flex flex-wrap align-items-center'>
                                                        <label className="custom-checkbox me-4 mb-0">
                                                            <input
                                                                type="checkbox"
                                                                name="checksheet"
                                                                checked={TaskData.chat === 1}
                                                                onChange={(e) => setTaskData({ ...TaskData, chat: e.target.checked ? 1 : 0 })}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Pie Chart
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer bg-light d-flex justify-content-end gap-3 task-report-filter-footer">
                                            <button type="reset" name="reset_button" className="btn btn-exp-light px-4">
                                                <i className="fas fa-redo me-2"></i>Reset
                                            </button>
                                            <button type="submit" name="submit_button" className="btn btn-exp-green px-4">
                                                <i className="fas fa-chart-bar me-2"></i>Generate Report
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid px-0">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                        {!reportData.length > 0 ?
                            <div className="col-12">
                                <div className="card bg-warning-light mb-0">
                                    <div className="card-body">
                                        <div className="exp-no-data-found text-exp-red">
                                            <img className="task-img mb-3" src={process.env.PUBLIC_URL + 'assets/images/search-no-record-found.webp'} alt="No task" />
                                            <h6>No Record Found</h6>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <div className={`${TaskData.chat == 1?'col-lg-8':'col-lg-12'} col-md-12`}>
                                <div className='d-flex justify-content-end mb-3'>
                                    <button className='btn btn-secondary btn-sm' onClick={reactToPrintFn}>
                                        <i className="fas fa-print me-2"></i>
                                        Print
                                    </button>
                                </div>
                                {reportData.length > 0 ?
                                    <div className='card rounded-10 overflow-hidden mb-4'>
                                        <div className='card-header border-bottom-0'>
                                            {User && User.map((item) => (
                                                item.id == reportName ?
                                                    < div className="profile-wrap" key={item.id}>
                                                        <div className="exp-avtar bg-exp-yellow">
                                                            {item.user_photo != null ?
                                                                < img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" /> :
                                                                <span>{item.name != '' ? item.name.split(' ').length > 1 ? item.name.split(' ')[0].split('')[0] + item.name.split(' ')[1].split('')[0] : item.name.split('')[0] + item.name.split('')[1] : ""}</span>
                                                            }
                                                        </div>
                                                        <div className="ps-2 profile-name-wrap text-truncate">
                                                            <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                                                        </div>
                                                    </div> : ""
                                            ))
                                            }
                                        </div>
                                        <div className='card-body p-0'>
                                            <div className='table-responsive'>
                                                <Grid
                                                    data={reportData}
                                                    style={{ width: '100%', minWidth: '800px' }}
                                                    className='kendo-table-border-block report_kendo_table'
                                                >
                                                    <GridColumn
                                                        title="#"
                                                        width="80px"
                                                        headerClassName="fw-bold"
                                                        cell={(props) => (
                                                            <td>
                                                                <div><span className='fw-bold'>{props.dataItem.id}</span></div>
                                                            </td>
                                                        )}
                                                    />
                                                    <GridColumn
                                                        title="Task Name"
                                                        width="250px"
                                                        headerStyle={{ minWidth: '250px' }}
                                                        cellStyle={{ minWidth: '250px' }}
                                                        headerClassName="fw-bold"
                                                        cell={(props) => (
                                                            <td>
                                                                <div><span className='fw-bold'>{props.dataItem.name}</span></div>
                                                            </td>
                                                        )}
                                                    />

                                                    <GridColumn
                                                        title="Planned Date"
                                                        width="150px"
                                                        headerStyle={{ minWidth: '150px' }}
                                                        cellStyle={{ minWidth: '150px' }}
                                                        headerClassName="fw-bold"
                                                        cell={(props) => (
                                                            <td>
                                                                <div><span>{moment(props.dataItem.planned_date).format("DD-MM-YYYY h:mm A")}</span></div>
                                                            </td>
                                                        )}
                                                    />
                                                    <GridColumn
                                                        title="Completed Date"
                                                        width="150px"
                                                        headerStyle={{ minWidth: '150px' }}
                                                        cellStyle={{ minWidth: '150px' }}
                                                        headerClassName="fw-bold"
                                                        cell={(props) => (
                                                            <td>
                                                                <div><span>{props.dataItem.completed_date ? moment(props.dataItem.completed_date).format("DD-MM-YYYY h:mm A") : ''}</span></div>
                                                            </td>
                                                        )}
                                                    />
                                                    <GridColumn
                                                        title="Status"
                                                        width="150px"
                                                        headerStyle={{ minWidth: '150px' }}
                                                        cellStyle={{ minWidth: '150px' }}
                                                        headerClassName="fw-bold"
                                                        cell={(props) => (
                                                            <td>

                                                                <>
                                                                    {
                                                                        props.dataItem.completed_date ?
                                                                            <div>
                                                                                <span className={`badge ${calculateDelayInHoursEndTime(props.dataItem.planned_date, props.dataItem.completed_date) == '0:00' ? 'bg-success' : 'bg-danger'
                                                                                    }`}>{calculateDelayInHoursEndTime(props.dataItem.planned_date, props.dataItem.completed_date) == '0:00' ? "Completed" : "Delay Completed"}</span>
                                                                            </div> :
                                                                            <div>
                                                                                <span className={`badge ${calculateDelayInHoursEndTime(props.dataItem.planned_date, new Date()) == "0:00" ? 'bg-primary' : 'bg-warning'
                                                                                    }`}>{calculateDelayInHoursEndTime(props.dataItem.planned_date, new Date()) == "0:00" ? "To Be Completed" : "Pending"}</span>
                                                                            </div>
                                                                    }
                                                                </>

                                                            </td>
                                                        )}
                                                    />

                                                    <GridColumn
                                                        title="Delay"
                                                        width="150px"
                                                        headerStyle={{ minWidth: '150px' }}
                                                        cellStyle={{ minWidth: '150px' }}
                                                        headerClassName="fw-bold"
                                                        cell={(props) => (
                                                            <td>
                                                                <div><span className='text-danger'>{props.dataItem.completed_date ? calculateDelayInHoursEndTime(props.dataItem.planned_date, props.dataItem.completed_date) : calculateDelayInHoursEndTime(props.dataItem.planned_date, new Date())} hrs</span></div>
                                                            </td>
                                                        )}
                                                    />
                                                </Grid>
                                            </div>
                                        </div>
                                    </div>
                                    : ""
                                }
                            </div>
                        }
                        {reportData.length > 0 ?
                            <>
                                {/* {
                                    TaskData.pie == 1 ?
                                        <div className={`${hide ? 'col-lg-12' : 'col-lg-8'} col-md-12`}>
                                            <div className='card'>
                                                <div className='card-body'>
                                                    <div className='overflow-x-scroll'>
                                                        <div className='bar-card-report'>
                                                            <Bar data={BarData} options={options} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""
                                } */}
                                {TaskData.chat == 1 ?
                                    <div className='col-lg-4 col-md-6'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <Doughnut data={data} options={optionsChecksheet} />
                                            </div>
                                        </div>
                                    </div> : ""
                                }
                            </> : ""
                        }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment >
    )
}

export default TaskReportIndex
